import {createContext, useContext, useReducer} from 'react'

export const StateContext = createContext<any>({})
export const useStatesGlobalNoStorage = () => useContext(StateContext)

export const StateProvider = ({initialState, reducer, children}) => (
  <StateContext.Provider value={useReducer(reducer, initialState)}>
    {children}
  </StateContext.Provider>
)
